// AUTO-GENERATED — do not edit manually, run npm run icons
import { SvgIcon, type SvgIconProps } from '@mui/material';
import Svg from '@assets/icons/file-attachment-02.svg?react';

export const FileAttachment02Icon = (props: SvgIconProps) => (
  <SvgIcon component={Svg} inheritViewBox {...props} />
);
